import { render, staticRenderFns } from "./CloudStoreNews.vue?vue&type=template&id=3afe0524&scoped=true&"
import script from "./CloudStoreNews.vue?vue&type=script&lang=js&"
export * from "./CloudStoreNews.vue?vue&type=script&lang=js&"
import style0 from "./CloudStoreNews.vue?vue&type=style&index=0&id=3afe0524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe0524",
  null
  
)

export default component.exports